import BigNumber from 'bignumber.js'
import { Token } from '@pulsex/sdk'
import { CardBody, Flex, Text, CardRibbon } from '@pulsex/uikit'
import ConnectWalletButton from 'components/ConnectWalletButton'
import { useTranslation } from '@pulsex/localization'
import { BIG_ZERO } from '@pulsex/utils/bigNumber'
import { DeserializedPool } from '@pulsex/pools'
import { TokenPairImage } from 'components/TokenImage'
import AprRow from './AprRow'
import { StyledCard } from './StyledCard'
import CardFooter from './CardFooter'
import PoolCardHeader, { PoolCardHeaderTitle } from './PoolCardHeader'
import CardActions from './CardActions'

const PoolCard: React.FC<{ pool: DeserializedPool<Token>; account: string }> = ({ pool, account }) => {
  const { stakingToken, earningToken, isFinished, userData } = pool
  const { t } = useTranslation()
  const stakedBalance = userData?.stakedBalance ? new BigNumber(userData.stakedBalance) : BIG_ZERO
  const accountHasStakedBalance = stakedBalance.gt(0)

  const isPLSXPool = earningToken.symbol === 'PLSX' && stakingToken.symbol === 'PLSX'

  return (
    <StyledCard
      isFinished={isFinished}
      ribbon={isFinished && <CardRibbon variantColor="textDisabled" text={t('Finished')} />}
    >
      <PoolCardHeader isStaking={accountHasStakedBalance} isFinished={isFinished}>
        <PoolCardHeaderTitle
          title={isPLSXPool ? t('Manual') : t('Earn %asset%', { asset: earningToken.symbol })}
          subTitle={isPLSXPool ? t('Earn PLSX, stake PLSX') : t('Stake %symbol%', { symbol: stakingToken.symbol })}
        />
        <TokenPairImage primaryToken={earningToken} secondaryToken={stakingToken} width={64} height={64} />
      </PoolCardHeader>
      <CardBody>
        <AprRow pool={pool} stakedBalance={stakedBalance} />
        <Flex mt="24px" flexDirection="column">
          {account ? (
            <CardActions pool={pool} stakedBalance={stakedBalance} />
          ) : (
            <>
              <Text mb="10px" textTransform="uppercase" fontSize="12px" color="textSubtle" bold>
                {t('Start earning')}
              </Text>
              <ConnectWalletButton />
            </>
          )}
        </Flex>
      </CardBody>
      <CardFooter pool={pool} account={account} />
    </StyledCard>
  )
}

export default PoolCard
